import React, { Component } from "react";

import {
  View,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
} from "react-native";
import Text from "../../components_v2/TextFont";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import ArButton from "../../argon-ui/Button";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import { translate } from "../../locales/translate";

import Theme from "../../argon-ui/Theme";
import Loading from "../../components/Loading";
import * as CONSTS from "../../../assets/consts";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import { connect } from "react-redux";
import { faUser } from "../../../assets/consts/faCharCodes";
import InputBase from "../../nativeBase-ui/InputBase";
import { HStack, Toast } from "native-base";
import ToastAlert from "../../nativeBase-ui/ToastAlert";

const PASS_MIN_LEN = 4;

class AccountScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      accessToken: "",
      serverUrl: "",

      showingValidationConfirmPasswordMessage: false,
      validationMessage: "",
      errorUserName: null,
      errorPassword: null,
      errorPasswordConfirm: null,

      fullName: "",
      password: "",
      confirmPassword: "",
      shouldChangePassword: false,

      isFullNameValid: true,
      isPasswordValid: true,
      isConfirmPasswordValid: true,
      showPassword: false,
      showPasswordConfirm: false,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.Account"),
  });
  async componentDidMount() {
    try {
      let { currentServer, serverUrl } = this.props.AppReducer;
      this.setState({
        isLoading: false,
        accessToken: currentServer.accessToken,
        serverUrl,
        fullName: currentServer.userFullName,
      });
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false });
    }
  }

  validatePassword = (txt) => {
    var _pass = txt;
    return _pass && _pass.length >= PASS_MIN_LEN;
  };
  validateConfirmPassword = (txt) => {
    var _pass = txt;
    return _pass === this.state.password && _pass.length >= PASS_MIN_LEN;
  };

  validateFullName = (txt) => {
    var _name = txt;
    return _name && _name.length > 0;
  };

  validateForm() {
    let { fullName, password, shouldChangePassword, confirmPassword } =
      this.state;
    var errors = false;
    var errorUserName = null;
    var errorPassword = null;
    var errorPasswordConfirm = null;

    var isPasswordValid =
      !shouldChangePassword || this.validatePassword(password);
    if (!isPasswordValid)
      errorPassword = translate("login.errors.ShortPassword");

    var isConfirmPasswordValid =
      !shouldChangePassword || this.validateConfirmPassword(confirmPassword);
    if (!isConfirmPasswordValid)
      errorPasswordConfirm = translate("login.errors.DisMatchedPassword");

    var isFullNameValid = this.validateFullName(fullName);
    if (!isFullNameValid)
      errorUserName = translate("login.errors.EmptyFullName");
    if (errorUserName || errorPassword || errorPasswordConfirm) {
      errors = true;
    }
    this.setState({ isPasswordValid, isFullNameValid });

    var result = {
      isValid: isPasswordValid && isFullNameValid && isConfirmPasswordValid,
      errors,
      errorUserName,
      errorPassword,
      errorPasswordConfirm,
    };
    return result;
  }

  showValidationMessage(validationMessage, message = "") {
    this.setState({
      validationMessage: message,
      errorUserName: validationMessage.errorUserName,
      errorPassword: validationMessage.errorPassword,
      errorPasswordConfirm: validationMessage.errorPasswordConfirm,
    });
  }

  goBack = () => {
    try {
      // callback
      this.props.navigation.state.params &&
        typeof this.props.navigation.state.params.onGoBack == "function" &&
        this.props.navigation.state.params.onGoBack(this.state.fullName);
    } catch (e) {
      console.log(e);
    }
    this.props.navigation.goBack();
  };

  onSuccessfulUpdate = () => {
    let { fullName } = this.state;
    SecureStore.setItemAsync(CONSTS.USER_FULL_NAME, fullName);
    this.goBack();
  };

  save = async () => {
    var validation = this.validateForm();
    if (validation.isValid) {
      // do save,
      let {
        accessToken,
        serverUrl,
        fullName,
        password,
        shouldChangePassword,
        confirmPassword,
      } = this.state;
      if (!serverUrl.endsWith("/")) serverUrl += "/";

      this.setState({ isLoading: true });

      var requestUrl = `/Users/UpdateAccount`;
      if (Platform.OS != "web") {
        requestUrl = serverUrl + requestUrl;
      }
      try {
        fetch(requestUrl, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            fullName,
            password,
            confirmPassword,
            shouldChangePassword,
          }),
        }).then((res) => {
          if (res.status == 200) {
            this.onSuccessfulUpdate();
          } else {
            this.setState({ isLoading: false }, () => {
              this.showToast(translate("login.errors.FailedToUpdateAccount"));
            });
          }
        });
      } catch (error) {
        console.log(error);
        this.showToast(translate("login.errors.FailedToUpdateAccount"));
      }

      // then navigate back
    } else {
      if (validation.errors) {
        var { errorUserName, errorPassword, errorPasswordConfirm } = validation;

        this.showValidationMessage(validation);
      } else {
        this.showValidationMessage(null, translate(`login.errors.general`));
      }
    }
  };
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };
  render() {
    if (this.state.isLoading) return <Loading />;

    return (
      <KeyboardAvoidingView
        behavior="height"
        style={{
          flex: 1,
          marginHorizontal: 10,
          marginTop: 25,
          marginBottom: 5,
        }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        {/* form */}
        <View style={{ flex: 1 }}>
          <InputBase
            label={translate("login.fullName")}
            placeholder={""}
            showSubInput={true}
            isInvalid={this.state.errorUserName}
            errorMessage={this.state.errorUserName}
            onChangeText={(txt) => {
              this.setState({
                fullName: txt,
                isFullNameValid: this.validateFullName(txt),
              });
            }}
            icon={faUser}
            value={this.state.fullName}
          />
          {!this.state.shouldChangePassword && (
            <Text
              style={{
                color: Theme.COLORS.PRIMARY,
                marginTop: 20,
                marginHorizontal: 10,
              }}
              onPress={() => {
                this.setState({ shouldChangePassword: true });
              }}
            >
              {translate("login.resetPasswordHeading")}
            </Text>
          )}
          {this.state.shouldChangePassword && (
            <View style={{ marginTop: 25 }}>
              <View style={{ marginBottom: 10 }}>
                <InputBase
                  showSubInput={true}
                  isInvalid={this.state.errorPassword}
                  errorMessage={this.state.errorPassword}
                  value={this.state.password}
                  onChangeText={(txt) => {
                    this.setState({
                      password: txt,
                      isPasswordValid: this.validatePassword(txt),
                    });
                  }}
                  secureTextEntry={!this.state.showPassword}
                  label={translate("login.password")}
                  placeholder={translate("login.password")}
                  icon={faCharCodes.faLockAlt}
                  iconLeft={
                    <TouchableWithoutFeedback
                      onPress={() =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                    >
                      <View
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          paddingHorizontal: 14,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={
                            this.state.showPassword
                              ? faCharCodes.faEyeSlash
                              : faCharCodes.faEye
                          }
                          color={Theme.COLORS.MUTED}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  }
                />
              </View>
              <InputBase
                showSubInput={true}
                isInvalid={this.state.errorPasswordConfirm}
                errorMessage={this.state.errorPasswordConfirm}
                value={this.state.confirmPassword}
                onChangeText={(txt) => {
                  this.setState({
                    confirmPassword: txt,
                    isConfirmPasswordValid: this.validateConfirmPassword(txt),
                  });
                }}
                placeholder={translate("login.confirmPassword")}
                icon={faCharCodes.faLockAlt}
                secureTextEntry={!this.state.showPasswordConfirm}
                iconLeft={
                  <TouchableWithoutFeedback
                    onPress={() =>
                      this.setState({
                        showPasswordConfirm: !this.state.showPasswordConfirm,
                      })
                    }
                  >
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        paddingHorizontal: 14,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={
                          this.state.showPasswordConfirm
                            ? faCharCodes.faEyeSlash
                            : faCharCodes.faEye
                        }
                        color={Theme.COLORS.MUTED}
                      />
                    </View>
                  </TouchableWithoutFeedback>
                }
              />
            </View>
          )}
        </View>

        {/* buttons */}
        <HStack space={2}>
          <ArButton
            color="primary"
            onPress={() => this.save()}
            style={{ flex: 1 }}
          >
            {translate("app.confirm")}
          </ArButton>
          <ArButton
            color="muted"
            variant="outline"
            onPress={() => this.goBack()}
            style={{ flex: 1 }}
          >
            {translate("app.goBack")}
          </ArButton>
        </HStack>
      </KeyboardAvoidingView>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountScreen);
